<template>
  <div class="save-record">
    <div v-if="status===0">
      <div class="title">
        <span>保存录音</span>
        <div class="close-button" @click="close">
          <i></i>
        </div>
      </div>
      <div class="set-name">
        <p>录音名称</p>
        <input type="text" v-model="name" placeholder="请输入录音名称,以帮助您更好管理录音" maxlength="16">
        <div>{{name.length}}/16</div>
      </div>
      <div class="button-content">
        <el-button type="primary" @click="saveUpload()">确定</el-button>
      </div>
    </div>
    <div v-else>
      <div class="upload-help">
        <div>录音正在上传中</div>
      </div>
      <div class="upload-cancel">
        <el-button @click="cancelUpload()">取消上传</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SaveRecord',
  data() {
    return {
      status: 0,
      name: '',
      number: 1
    }
  },
  methods: {
    saveUpload() {
      if(this.name.length <= 0) {
        this.name = '未命名录音' + (this.number <= 10 ? '0' + this.number : this.number);
        this.number++ ;
      }
      this.$emit('saveUpload', {name: this.name})
      this.status = 1;
    },
    close () {
      this.$emit('close')
      this.status = 0;
    },
    cancelUpload() {
      this.close()
      this.$emit('cancelUpload')
    }
  }
}
</script>
<style lang="scss" scoped>
.save-record {
  position: relative;
  margin: auto;
  width: 370px;
  height: 240px;
  background: #fff;
  border-radius: 3px;
  color: #474261;
  overflow: hidden;
}
.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 12px 0 15px;
  height: 28px;
  background-color: #d8dee9;
  color: #474261;
}
div.close-button {
  position: absolute;
  right: 10px;
  top: 5px;
  width: 16px;
  cursor: pointer;

  i {
    position:relative;
    left: 0px;
    top: 2px;
    width: 2px;
    height: 15px;
    border-radius: 3px;
    background: #737596;
    transform: rotate(45deg);
    display: inline-block;

    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 2px;
      height: 15px;
      border-radius: 3px;
      background: #737596;
      transform: rotate(270deg);
    }
  }
}

.set-name {
  padding-left: 20px;
  padding-right: 20px;
  margin-bottom: 20px;
  margin-top: 40px;

  p {
    margin-bottom: 13px;
    font-size: 14px;
  }
  input {
    height: 37px;
    width: 100%;
    padding-left: 12px;
    box-sizing: border-box;
    background-color: #f6f6fc;
    border-radius: 2px;
    border: none;

    &::placeholder {
      color: #9692A9;
    }
  }
  div {
    position: relative;
    top: -26px;
    right: -280px;
    width: 40px;
    text-align: right;
  }
}
.button-content {
  text-align: center;

  button {
    height: 36px;
    padding: 10px 34px;
  }
}
.upload-help {
  margin-top: 80px;
  font-size: 20px;
  text-align: center;
}
.upload-cancel {
  margin-top: 20px;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/subtitle/record/saveRecord.vue